import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    addTransaction,
    changeTransaction,
    emptyTransaction,
} from "../features/transaction/transactionSlice";

export const Form = () => {
    const { transaction } = useSelector((state) => state.transaction) || {};
    const dispatch = useDispatch();
    // form state
    const [name, setName] = useState("");
    const [type, setType] = useState("");
    const [amount, setAmount] = useState("");
    // is edit
    const [isEdit, setEdit] = useState(false);

    // add transaction
    const addSubmit = (e) => {
        e.preventDefault();
        const data = {
            name,
            type,
            amount: Number(amount),
        };
        dispatch(addTransaction(data));
        clearFOrmState();
    };

    useEffect(() => {
        const { id, name, type, amount } = transaction;
        if (id) {
            setEdit(true);
            setName(name);
            setType(type);
            setAmount(amount);
        } else {
            setEdit(false);
            clearFOrmState();
        }
    }, [transaction]);

    // update trasaction
    const updateSubmit = (e) => {
        e.preventDefault();

        const data = {
            name,
            type,
            amount: Number(amount),
        };

        dispatch(changeTransaction({ id: transaction.id, data }));
        dispatch(emptyTransaction());
        clearFOrmState();
    };

    // cancel transaction
    const cancelHandler = () => {
        setEdit(false);
        clearFOrmState();
        dispatch(emptyTransaction());
    };

    // clear form state
    const clearFOrmState = () => {
        setName("");
        setType("");
        setAmount("");
    };

    return (
        <>
            <div className="bg-blue-200 md:w-4/12 mx-auto p-4 rounded-b">
                <form onSubmit={isEdit ? updateSubmit : addSubmit}>
                    <div className="mb-3">
                        <input
                            type="text"
                            placeholder="Item Name"
                            className="h-10 px-3 w-full focus:outline-none text-sm rounded"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                    <div className="flex items-center gap-8 mb-3">
                        <label className="flex items-center gap-1">
                            <input
                                type="radio"
                                name="type"
                                value="income"
                                checked={type === "income"}
                                onChange={(e) => setType(e.target.value)}
                            />
                            <span className="text-blue-700">Income</span>
                        </label>
                        <label className="flex items-center gap-1">
                            <input
                                type="radio"
                                name="type"
                                value="expense"
                                checked={type === "expense"}
                                onChange={(e) => setType(e.target.value)}
                            />
                            <span className="text-blue-700">Expense</span>
                        </label>
                    </div>
                    <div className="mb-3">
                        <input
                            type="number"
                            placeholder="Price"
                            className="h-10 px-3 w-full focus:outline-none text-sm rounded"
                            required
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </div>
                    <button className="h-10 w-full bg-blue-700 text-sm text-blue-200 rounded hover:bg-blue-800 duration-200 mb-3">
                        {isEdit ? "Update Transaction" : "Add Transaction"}
                    </button>
                </form>
                {isEdit && (
                    <button
                        onClick={cancelHandler}
                        className="h-10 w-full bg-red-500 text-sm text-red-200 rounded hover:bg-red-600 duration-200"
                    >
                        Cancel Transaction
                    </button>
                )}
            </div>
        </>
    );
};
